module.exports = "<div>\r\n    <!--<i *ngIf=\"params.data.fin_sw != 'N'\" class=\"fa fa-eye\" aria-hidden=\"true\" (click)=\"params.data.defaultAction='view'; view()\"></i>-->\r\n    <i  class=\"fa fa-pencil\" aria-hidden=\"true\" (click)=\"params.data.defaultAction='view'\"></i>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/gridview/gridview.component.html
// module id = ./src/app/gridview/gridview.component.html
// module chunks = main